import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const ScientificWritingPage = () => {
  return <TechnicalServicePage serviceKey="scientificWriting" />
}

export default ScientificWritingPage
